var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdsMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2546_115445)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3.5C0.5 1.84315 1.84315 0.5 3.5 0.5H8.5C10.1569 0.5 11.5 1.84315 11.5 3.5V8.5C11.5 10.1569 10.1569 11.5 8.5 11.5H8V10C8 9.72386 7.77614 9.5 7.5 9.5C7.22386 9.5 7 9.72386 7 10V11.5H5V10C5 9.72386 4.77614 9.5 4.5 9.5C4.22386 9.5 4 9.72386 4 10V11.5H3.5C1.84315 11.5 0.5 10.1569 0.5 8.5V3.5ZM2.75 4.5C2.75 4.22386 2.97386 4 3.25 4H8.75C9.02614 4 9.25 4.22386 9.25 4.5C9.25 4.77614 9.02614 5 8.75 5H3.25C2.97386 5 2.75 4.77614 2.75 4.5ZM3.25 6.5C2.97386 6.5 2.75 6.72386 2.75 7C2.75 7.27614 2.97386 7.5 3.25 7.5H8.75C9.02614 7.5 9.25 7.27614 9.25 7C9.25 6.72386 9.02614 6.5 8.75 6.5H3.25Z",
    fill: "#AC92ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2546_115445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsMessage);
export default __webpack_public_path__ + "static/media/ads_message.7ec5cb5965e3e8c08fdba929b50575b6.svg";
export { ForwardRef as ReactComponent };